import { rtkApi } from '@/shared/api/rtkApi';

export type BillingTariffRole = 'admin' | 'player' | 'observer' | 'viewer' | 'training' | 'referee' | 'developer';
export type EditableBillingTariffRole = Exclude<BillingTariffRole, 'developer'>;

export type BillingTariffs = Record<BillingTariffRole, number>;
export type EditableBillingTariffs = Partial<Record<EditableBillingTariffRole, number>>;

export interface BillingTariffsResponse {
  tariffs: BillingTariffs;
}

const billingTariffApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getBillingTariffs: build.query<BillingTariffsResponse, void>({
      query: () => '/v1/superadmin/billing/tariffs',
      providesTags: ['BillingTariffs'],
    }),
    updateBillingTariffs: build.mutation<BillingTariffsResponse, EditableBillingTariffs>({
      query: (tariffs) => ({
        url: '/v1/superadmin/billing/tariffs',
        method: 'PATCH',
        body: { tariffs },
      }),
      invalidatesTags: (_result, error) => (error ? [] : ['BillingTariffs']),
    }),
  }),
});

export const { useGetBillingTariffsQuery, useUpdateBillingTariffsMutation } = billingTariffApi;
